import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
        <div>
            <NavMenu className="mb-3"/>
            <Container className="pt-4">
              {this.props.children}
            </Container>
        </div>
    );
  }
}
